exports = module.exports = require("../../../../node_modules/_css-loader@0.23.1@css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".engine-panes{position:absolute;right:0;top:0;bottom:0;left:0;z-index:1;transition:top .2s;background:var(--color-block-background-shallow,rgba(31,56,88,.06))}.engine-panes>.engine-pane{position:absolute;box-sizing:border-box}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/_css-loader@0.23.1@css-loader!./~/_less-loader@2.2.3@less-loader!./lib/engine/ui/panes/index.less
// module id = 268
// module chunks = 0